import styled from "styled-components";

import {
    VOTEBOX_FONT_SIZE_SMALL,
    VOTEBOX_SECONDARY_TEXT_COLOR,
} from "components/vote/Votebox/common/voteboxTokens";

export const NumberOfVoicesText = styled.div`
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
    padding-bottom: 0.75rem;
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
`;
